// recon-receivables-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcr.flag.old': 'Gammel post over 90 dager',
  'rcr.flag.overdue30': 'Forfalt over 30 dager',
  'rcr.flag.negative': 'Negativ kundesaldo',
  'rcr.flag.duplicate': 'Mulig duplikat',
  'rcr.flag.partlyPaid': 'Delbetalt, fortsatt åpen',
  'rcr.flag.creditNoteOpen': 'Kreditnota ikke utlignet',
  'rcr.flag.collection': 'Inkassovarsel sendt',
  'rcr.flag.lossRisk': 'Tapsrisiko',
  'rcr.flag.missingDoc': 'Mangler fakturadokument',
  'rcr.flag.paidAfter': 'Innbetalt etter periodedato',
  'rcr.flag.creditNoteAfter': 'Kreditnota etter periodedato',
  'rcr.flag.disputed': 'Omtvistet faktura',
  'rcr.age.noDueDate': 'Uten forfallsdato',
  'rcr.age.notDue': 'Ikke forfalt',
  'rcr.age.d1_30': '1–30 dager forfalt',
  'rcr.age.d31_60': '31–60 dager forfalt',
  'rcr.age.d61_90': '61–90 dager forfalt',
  'rcr.age.over90': 'Over 90 dager forfalt',
  'rcr.collection.noticeOne': 'Inkassovarsel sendt',
  'rcr.collection.noticeMany': '{count} inkassovarsler sendt',
  'rcr.collection.reminderOne': 'Én purring sendt',
  'rcr.collection.reminderMany': '{count} purringer sendt',
  'rcr.collection.invoiceSent': 'Faktura sendt',
  'rcr.collection.notSent': 'Ikke sendt',
  'rcr.collection.imported': 'Importert åpen post',
  'rcr.type.creditNote': 'Kreditnota',
  'rcr.type.invoice': 'Faktura',
  'rcr.type.importedCredit': 'Importert kundekredit',
  'rcr.type.importedInvoice': 'Importert faktura',
  'rcr.fallback.importedItem': 'Importert post',
  'rcr.check.ledgerVsSubledger': 'Hovedbok mot reskontro',
  'rcr.check.old': 'Gamle poster over 90 dager',
  'rcr.check.overdue30': 'Forfalte poster over 30 dager',
  'rcr.check.negative': 'Negative kundesaldoer',
  'rcr.check.partlyPaid': 'Delbetalt, men fortsatt åpen',
  'rcr.check.creditNoteOpen': 'Kreditnotaer som ikke er utlignet',
  'rcr.check.duplicates': 'Mulige duplikater',
  'rcr.check.collection': 'Inkassovarsler sendt',
  'rcr.check.lossRisk': 'Poster med tapsrisiko',
  'rcr.check.paidAfter': 'Etterfølgende innbetaling',
  'rcr.check.creditNoteAfter': 'Kreditnota etter periodedato',
  'rcr.check.direct': 'Direkteføringer på kontrollkonto',
  'rcr.check.missingDoc': 'Manglende fakturadokument',
  'rcr.check.noSubledgerNote': 'Ingen kontrollkonto med reskontro i området',
});
